<template>
    <v-form ref="form" class="form-container">
        <v-textarea
            v-model="textTemplate"
            class="form-field"
            :label="`Viber text template, You can use up to ${getCurrentViberCampaign.params} placeholder(s)`"
            hint=" Click on the bellow buttons to insert a placeholder to your Viber text, each placeholder represents column 2 and above. Column 1 is reserved for your recipient(s) list."
            :rules="[
                v => !!v || 'Field Required'
            ]"
            required
        />
        <div v-if="getCurrentViberCampaign" class="params-container">
            <div
                v-for="param in getCurrentViberCampaign.params"
                :key="param"
            >
                <v-btn
                    color="cyan"
                    dark
                    @click="addParamInText(param)"
                >
                    Param {{ param }}
                </v-btn>
            </div>
        </div>
        <v-textarea
            v-if="getCurrentViberCampaign && getCurrentViberCampaign.fallback"
            v-model="fallbackTextTemplate"
            class="form-field"
            :label="`SMS Fallback text template, You can use up to ${getCurrentViberCampaign.params} placeholder(s)`"
            hint="Click on the bellow buttons to insert a placeholder to your SMS Fallback text, each placeholder represents column 2 and above. Column 1 is reserved for your recipient(s) list."
            :rules="[
                v => !!v || 'Field Required'
            ]"
            required
        />
        <div v-if="getCurrentViberCampaign && getCurrentViberCampaign.fallback" class="params-container">
            <div
                v-for="param in getCurrentViberCampaign.params"
                :key="param"
            >
                <v-btn
                    color="cyan"
                    dark
                    @click="addParamInFallbackText(param)"
                >
                    Param {{ param }}
                </v-btn>
            </div>
        </div>
        <create-form-actions
            :continue-loading="submitLoading"
            :continue-disabled="submitLoading"
            has-previous-step-btn
            @next-step="emitNextStep"
            @previous-step="emitPrevStep"
            @cancel="emitCancel"
            @reset="emitReset"
        />
    </v-form>
</template>

<script>
    import CreateFormActions from '@/components/CreateFormActions.vue'
    import EventBus from '@/event-bus'
    export default {
        components: { CreateFormActions },
        data() {
            return {
                textTemplate: '',
                fallbackTextTemplate: null,
                submitLoading: false
            }
        },
        computed: {
            getCurrentViberCampaign() {
                return this.$store.getters.getCurrentRecurringViberCampaign
            }
        },
        created() {
            EventBus.$on('reset-new-campaign-form', () => {
                this.textTemplate = ''
                this.fallbackTextTemplate = null
                this.submitLoading = false
            })
        },
        methods: {
            addParamInText(param) {
                this.textTemplate += ` {PARAM${param}} `
            },
            addParamInFallbackText(param) {
                if (this.fallbackTextTemplate === null) {
                    this.fallbackTextTemplate = ''
                }
                this.fallbackTextTemplate += ` {PARAM${param}} `
            },
            emitNextStep() {
                if (!this.$refs.form.validate()) { return }
                const campaign = {
                    ...this.getCurrentViberCampaign,
                    textTemplate: this.textTemplate,
                    fallbackTextTemplate: this.fallbackTextTemplate // TODO: Check if we need to convert it to null if it's an empty string
                }
                this.$store.dispatch('setRecurringViberCampaign', campaign)
                this.$emit('next-step')
            },
            emitPrevStep() {
                this.$emit('prev-step')
            },
            emitCancel() {
                this.$emit('cancel')
            },
            emitReset() {
                this.$emit('reset')
            }
        }
    }
</script>

<style scoped>

.params-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 15px;
    margin-bottom: 20px;
}

.form-container {
    margin-bottom: 10px;
}

.form-field {
    width: 100%;
    margin-bottom: 30px;
    padding-left: 15px !important;
    padding-right: 15px !important;
}

</style>
